import { useEffect, useState, useRef } from 'react';
import { Box, Fade, Flex, useToast } from "@chakra-ui/react";
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton';
import { IoCopyOutline } from 'react-icons/io5';
import { copyToUserClipboard, triggerLaunchdeckToast } from '../../global/helpers/global-helpers';
import config from "../../../config/app-config";
import { QRCodeSVG } from "qrcode.react";
import { MdOutlineShare } from 'react-icons/md';
import useLaunchdeckModal from '../../global/hooks/use-launchdeck-modal';

export default function ShareProspectDsrButton({
  pDsrId,
  dsrStatus,
  isMobileView,
  showShareElements
}) {

  const toast = useToast();
  const ref = useRef(null);
  const { openLaunchdeckModal } = useLaunchdeckModal();
  const [showShareLinkBox, setShowShareLinkBox] = useState(false)

  useEffect(() => {
    document.addEventListener("click", handleClickOutsideShareLinkArea, true);
    return () => {
      document.removeEventListener("click", handleClickOutsideShareLinkArea, true);
    };
  });

  useEffect(() => {
    if (showShareElements) {
      // setShowShareLinkBox(showShareElements)
      setTimeout(() => setShowShareLinkBox(true), 100);
    }
  }, [showShareElements]);

  const renderCopyInviteLinkButton = () => {
    if (dsrStatus === "active") {
      return (
        <Flex color='brand.500' cursor='pointer' align='center' onClick={() => {
          handleCopyLink()
          setShowShareLinkBox(false)
        }}>
          <Box as={IoCopyOutline} boxSize='1em' ml='1em' />
        </Flex>
      )
    } else return null;
  }

  const handleCopyLink = () => {
    if (pDsrId) {
      copyToUserClipboard(`${config.displayUrl}/pdsr/${pDsrId}`)

      toast(
        triggerLaunchdeckToast({
          useCase: "show-success-state",
          // bannerText: "",
          label: "Prospector Link copied",
          isMobileView
        })
      )
    }

    if (!pDsrId) {
      toast(
        triggerLaunchdeckToast({
          useCase: "show-error-state",
          bannerText: "Error copying link",
          label: "Unfortunately something went wrong. Please try again later.",
          isMobileView
        })
      )
    }

  }

  const renderCopyLinkText = () => {
    let copyLinkText = "";

    if (dsrStatus === "active") {
      copyLinkText = `${config.displayUrl}/pdsr/${pDsrId}`;

    } else {
      copyLinkText = "Link has been deactivated as this Room is not yet published"
    }

    return copyLinkText;
  }

  const handleClickOutsideShareLinkArea = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setShowShareLinkBox(false)
    }
  };

  const handleClickButton = () => {
    if (isMobileView) {
      openLaunchdeckModal('share-prospect-dsr')
    } else {
      setShowShareLinkBox(!showShareLinkBox)
    }

  }

  return (
    <>
      <Box position='relative'>
        {isMobileView ?
          <Box
            onClick={() => handleClickButton()}
            cursor='pointer'
            p='0.1em'
            bg='brand.500'
            rounded='50%'
            color='white'
            boxSize='1.75em'
            align='center'
            alignContent='center'
          >

            <MdOutlineShare />

          </Box>
          :
          <LaunchdeckButton
            bg={'gray.500'}
            color={'white'}
            onClick={() => handleClickButton()}
            fontSize={'0.8em'}
          >
            Share
          </LaunchdeckButton>


        }


        {(showShareLinkBox) &&
          <Fade in={true}>
            <Box data-driver="prospector-tour-step-2" position='absolute' name="display-share-link-area" ref={ref} p='1.5em' bg='white' rounded='0.25em' top='3em' right='0em' border='1px solid' borderColor='gray.300' boxShadow="xs">
              <Box fontSize='0.875em' fontWeight='600' fontColor='brandDark.500'> Share link with people </Box>
              <Flex className='invite-link-container' w='100%' mt='0.5em'>
                <Box className="truncate-long-text" maxW='25em'>{renderCopyLinkText()}</Box>
                {renderCopyInviteLinkButton()} 
              </Flex>
              <Box display='flex' width='100%' justifyContent='center' mt='2em'>
                <QRCodeSVG value={`${config.displayUrl}/pdsr/${pDsrId}`} />
              </Box>
            </Box>
          </Fade>
        }
      </Box>
    </>
  );
};